/** 
 * Translated from enum com.dataiku.dip.dataflow.exec.joinlike.ConditionsMode
 * Via: com.dataiku.dip.dataflow.exec.joinlike.JoinDescBase
 */
export enum ConditionsMode {
    AND = "AND",
    OR = "OR",
    NATURAL = "NATURAL",
    CUSTOM = "CUSTOM",
}